export default __webpack_public_path__ + "static/media/IconDesc_Gunpowder.256.f6d8d75f.png";